import { IParticipante, Participante } from '@/components/participantes/participante.model';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';

/**
 * Contiene un valor de Opción de Empleado en.
 */
export interface IEmpleadoEn {
  clave?: string;
  descripcion?: string;
}

export class EmpleadoEn implements IEmpleadoEn {
  constructor(public clave?: string, public descripcion?: string) {}
}

/**
 * Contiene un item de menú Empleado en.
 */
export interface IMenuEmpleadoEn {
  value?: EmpleadoEn;
  text?: string;
  disabled?: boolean;
}

export class MenuEmpleadoEn implements IMenuEmpleadoEn {
  constructor(public value?: EmpleadoEn, public text?: string, public disabled?: boolean) {}
}

/**
 * Contiene un valor de Opción de Trabaja.
 */
export interface ITrabaja {
  clave?: string;
  descripcion?: string;
}

export class Trabaja implements ITrabaja {
  constructor(public clave?: string, public descripcion?: string) {}
}

/**
 * Contiene un item de menú Trabaja.
 */
export interface IMenuTrabaja {
  value?: Trabaja;
  text?: string;
  disabled?: boolean;
}

export class MenuTrabaja implements IMenuTrabaja {
  constructor(public value?: Trabaja, public text?: string, public disabled?: boolean) {}
}

/**
 * Contiene un valor de Opción de graduación.
 */
export interface IOpcionGraduacion {
  clave?: string;
  descripcion?: string;
}

export class OpcionGraduacion implements IOpcionGraduacion {
  constructor(public clave?: string, public descripcion?: string) {}
}

/**
 * Contiene un item de Opción de graduación.
 */
export interface IMenuOpcionGraduacion {
  value?: OpcionGraduacion;
  text?: string;
  disabled?: boolean;
}

export class MenuOpcionGraduacion implements IMenuOpcionGraduacion {
  constructor(public value?: OpcionGraduacion, public text?: string, public disabled?: boolean) {}
}

/**
 * Contiene una opción de Acta.
 */
export interface IActa {
  clave?: string;
  descripcion?: string;
}

export class Acta implements IActa {
  constructor(public clave?: string, public descripcion?: string) {}
}

/**
 * Contiene un item de una opción de Acta.
 */
export interface IMenuActa {
  value?: Acta;
  text?: string;
  disabled?: boolean;
}

export class MenuActa implements IMenuActa {
  constructor(public value?: Acta, public text?: string, public disabled?: boolean) {}
}

/**
 * Contiene un tipo de beca.
 */
export interface ITipoBeca {
  clave?: string;
  descripcion?: string;
}

export class TipoBeca implements ITipoBeca {
  constructor(public clave?: string, public descripcion?: string) {}

  static fromObject(item: ITipoBeca): TipoBeca {
    const tipoBeca = new TipoBeca();

    for (const [key, value] of Object.entries(item)) {
      tipoBeca[key] = value;
    }

    return tipoBeca;
  }
}

/**
 * Contiene una opción de un tipo de beca.
 */
export interface IMenuTipoBeca {
  value?: TipoBeca;
  text?: string;
  disabled?: boolean;
}

export class MenuTipoBeca implements IMenuTipoBeca {
  constructor(public value?: TipoBeca, public text?: string, public disabled?: boolean) {}
}

/**
 * Contiene un tiempo de dedicación
 */
export interface ITiempoDedicacion {
  value?: string;
  text?: string;
}

export class TiempoDedicacion implements ITiempoDedicacion {
  constructor(public value?: string, public text?: string) {}
}

/**
 * Contiene una opción del menú de institución y de sede
 */
export interface IMenuInstitucionSnp {
  value?: InstitucionSnp;
  text?: string;
}

export class MenuInstitucionSnp implements IMenuInstitucionSnp {
  constructor(public value?: InstitucionSnp, public text?: string) {}
}

export interface IMenuSedeSnp {
  value?: SedeSnp;
  text?: string;
}

export class MenuSedeSnp implements IMenuSedeSnp {
  constructor(public value?: SedeSnp, public text?: string) {}
}

/**
 * Contiene los datos de una institución y una sede.
 */
export interface ISedeSnp {
  claveSede?: string;
  claveDependencia?: string;
  nombreDependencia?: string;
  sede?: string;
}

export class SedeSnp implements ISedeSnp {
  constructor(public claveSede?: string, public claveDependencia?: string, public nombreDependencia?: string, public sede?: string) {}
}

export interface IInstitucionSnp {
  claveInstitucion?: string;
  nombreInstitucion?: string;
}

export class InstitucionSnp implements IInstitucionSnp {
  constructor(public claveInstitucion?: string, public nombreInstitucion?: string) {}
}

/**
 * Guarda los datos de la participación para base de datos.
 */
export interface IParticipacionSnp {
  id?: string;
  solicitudId?: string;
  solucionId?: string;
  contenedorId?: string;
  dependenciaId?: string;
  participante?: IParticipante;
  rol?: RolAutoridad;
  tipoParticipacion?: string;
  estadoBeca?: string;
}

export class ParticipacionSnp implements IParticipacionSnp {
  constructor(
    public id?: string,
    public solicitudId?: string,
    public solucionId?: string,
    public contenedorId?: string,
    public dependenciaId?: string,
    public participante?: IParticipante,
    public rol?: RolAutoridad,
    public tipoParticipacion?: string,
    public estadoBeca?: string
  ) {
    if (!participante) {
      this.participante = new Participante();
    }
  }

  static fromObject(item: IParticipacionSnp): ParticipacionSnp {
    const participante = new ParticipacionSnp();

    const transformations = {
      participante: (participante: Participante) => (participante !== undefined ? Participante.fromObject(participante) : undefined),
    };

    for (const [key, value] of Object.entries(item)) {
      const transform = transformations[key as keyof IParticipacionSnp];
      participante[key] = transform ? transform(value) : value;
    }
    participante.tipoParticipacion = participante.participante.obtencionGrado?.length > 0 ? 'GRADUADO' : 'ESTUDIANTE';
    return participante;
  }
}

export interface IInicioGeneracion {
  value?: string;
  text?: string;
}

export class InicioGeneracion implements IInicioGeneracion {
  constructor(public value?: string, public text?: string) {}
}
